import { useEffect } from "react";
import useApiHook from "../../utils/useApi";
import { MerchantsResponse } from "../../interface/types";
import MerchantNumber from "../components/merchants/merchantCard/MerchantNumber";
import MerchantTable from "../components/merchants/table/MerchantTable";

const AdminDashboard = () => {
  const { data, isLoading, makeRequest } = useApiHook<MerchantsResponse>(
    "/admin/merchants",
    {
      method: "get",
    }
  );

  useEffect(() => {
    makeRequest();
  }, []);

  const totalCount = data?.data?.totalCount || 0;

  return (
    <main className="flex flex-col justify-center p-4 max-w-6xl  mx-auto">
      <MerchantNumber numberOfMerchants={totalCount} isLoading={isLoading} />
      <MerchantTable />
    </main>
  );
};

export default AdminDashboard;
